import { FilePurpose } from '@/api/enums';
import { User } from '@/client/users';

export type File = {
  id: string;
  bucket: string;
  remote: string;
  fileName: string;
  mimeType: string;
  size: number;
  extension: string;
  created: Date;
  signedUrl: string;
  updated: Date | null;
  user: User;
  purpose: FilePurpose;
};

export const FileType = {
  VIDEO: 'VIDEO',
  PDF: 'PDF',
  SCORM: 'SCORM',
  WORD: 'WORD',
  POWERPOINT: 'POWERPOINT',
  EXCEL: 'EXCEL',
};

export const FileExtensions = {
  [FileType.VIDEO]: ['.mp4'],
  [FileType.PDF]: ['.pdf'],
  [FileType.SCORM]: ['.zip'],
  [FileType.WORD]: ['.docx', '.doc'],
  [FileType.POWERPOINT]: ['.pptx', '.ppt'],
  [FileType.EXCEL]: ['.xlsx', '.xls'],
};
